(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wijnhuizen-overzicht"] && !Shopify.designMode) return;
  try {
    
  // Client-side filter: verbergt kaarten, lege lettergroepen en indexletters
  // die niet matchen. Accent-ongevoelig via NFD-normalisatie ("chateau" vindt "Château").
  document.querySelectorAll('.wijnhuizen-hub').forEach((hub) => {
    const input = hub.querySelector('.wijnhuizen-hub__search');
    if (!input) return;
    const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const items = [...hub.querySelectorAll('.wijnhuizen-hub__item')];
    const groups = [...hub.querySelectorAll('.wijnhuizen-hub__group')];
    const indexLinks = [...hub.querySelectorAll('.wijnhuizen-hub__index-link')];
    const noResults = hub.querySelector('.wijnhuizen-hub__no-results');

    input.addEventListener('input', () => {
      const q = norm(input.value.trim());
      items.forEach((li) => {
        li.hidden = q !== '' && !norm(li.dataset.zoek).includes(q);
      });
      groups.forEach((group) => {
        group.hidden = !group.querySelector('.wijnhuizen-hub__item:not([hidden])');
      });
      indexLinks.forEach((a) => {
        const target = hub.querySelector(a.getAttribute('href'));
        a.parentElement.hidden = !target || target.hidden;
      });
      if (noResults) noResults.hidden = items.some((li) => !li.hidden);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
